import "./app.scss";
import Main from "./layouts/Main";
import { AppProvider } from "./contexts/AppContext";
import UIAudio from "./UIAudio";
import WIPSketchCanvas from "./components/WIPSketchCanvas/WIPSketchCanvas";
import { useEffect } from "react";
import DeviceGradeDetection from "./util/DeviceGradeDetection";

const _AudioContext =
  window.AudioContext ||
  window.webkitAudioContext ||
  window.mozAudioContext ||
  window.oAudioContext ||
  window.msAudioContext;

export const audioContext = new _AudioContext();
export const uiAudio = new UIAudio();

export const USE_BASIS_TEXTURES = true;

const App = () => {
  // return <WIPSketchCanvas />;
  return (
    <AppProvider>
      <Main />
    </AppProvider>
  );
};

export default App;
